export default class PecicaObj {
    ratings = [
        //200   nad 200
        [1.12,	1.57], // 1998
        [1.04,	1.46], // 1999 - 07
        [0.78,	1.09], // 2008 -
        [0.86,	1.20], // A vecsistemska
        [0.92,	1.29], // A konvencionalna
        [0.62,	0.87], // A+ vecsistemska
        [0.82,	1.15], // A+ konvencionalna
    ];

    strings = [
        "do 1998",  
        "od 1998 do 2007",
        "od 2007",        
        "A - konvencionalna",
        "A - večsistemska",
        "A+ - konvencionalna",
        "A+ - večsistemska",
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(starost, teden, vikend, teden2, vikend2) {
        this.st_select = 10;
        this.short = "P";
        this.st_ukrepov = 0;
        this.name = "Pečica";

        this.curr_use = this.ratings[starost - 1][0] * (teden + vikend) + this.ratings[starost - 1][1] * (teden2 + vikend2) * 52; 
        this.detail_string = this.strings[starost - 1];
    }
}
